module.exports = __webpack_public_path__ + "img/step3-2.cbb40af9.png";